import { render } from "./CompanyEvents.vue?vue&type=template&id=2c3247d4"
import script from "./CompanyEvents.vue?vue&type=script&lang=js"
export * from "./CompanyEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__